import { supabase } from '../lib/supabase';

export const replyService = {
  // Get replies for a review
  async getReplies(reviewId) {
    const { data, error } = await supabase
      .from('review_replies')
      .select('*')
      .eq('review_id', reviewId)
      .order('created_at', { ascending: true });
    
    if (error) throw error;
    return data;
  },

  // Get all replies (for admin)
  async getAllReplies() {
    const { data, error } = await supabase
      .from('review_replies')
      .select(`
        *,
        reviews!inner(user_name, title)
      `)
      .order('created_at', { ascending: false });
    
    if (error) throw error;
    return data;
  },

  // Create a new reply
  async createReply(replyData) {
    console.log('Creating reply with data:', replyData);
    
    try {
      const { data, error } = await supabase
        .from('review_replies')
        .insert([replyData])
        .select();
      
      if (error) {
        console.error('Supabase error details:', {
          message: error.message,
          details: error.details,
          hint: error.hint,
          code: error.code
        });
        throw error;
      }
      
      console.log('Reply created successfully:', data);
      return data[0];
    } catch (error) {
      console.error('Full error object:', error);
      throw error;
    }
  },

  // Update a reply
  async updateReply(id, replyData) {
    const { data, error } = await supabase
      .from('review_replies')
      .update(replyData)
      .eq('id', id)
      .select();
    
    if (error) throw error;
    return data[0];
  },

  // Delete a reply
  async deleteReply(id) {
    const { error } = await supabase
      .from('review_replies')
      .delete()
      .eq('id', id);
    
    if (error) throw error;
  }
}; 